import { template as template_11d60b652a564d7083e91941c4f11d78 } from "@ember/template-compiler";
import RouteTemplate from 'ember-route-template';
export default RouteTemplate(template_11d60b652a564d7083e91941c4f11d78(`
<div class="landing-page">
  <img src="/images/epicor-logo-blue.png" />
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}));
